import { FC, memo, Suspense } from "react";
import Script from "next/script";

import DefaultHead from "../components/page/DefaultHead/DefaultHead";
import SkipToContent from "../components/page/SkipLink/SkipLink";
import Main from "../components/layout/Main/Main";
import { makePageTags } from "../utils/website/head";
import Container from "../components/layout/Container/Container";
import Grid from "../components/layout/Grid/Grid";
import Column from "../components/layout/Column/Column";
import Logo from "../components/base/Icon/Logo/Logo";
import BackButton from "../components/feature/BackButton/BackButton";

import { HEADER_SCRIPTS, ILayout } from "./layouts.map";

export const SharedHead: FC<Omit<ILayout, "children" | "headerLinks">> = (
  { head, lastBuilt, scripts, schemaScripts },
) => (
  <>
    <DefaultHead
      /* @ts-ignore */
      seo={makePageTags(head?.seo)}
      /* @ts-ignore */
      hideFromSearch={head?.hide_from_search_engines}
      lastBuilt={lastBuilt}
      fallbackTags={head?.fallbackTags && makePageTags(head.fallbackTags)}
    >
      { scripts?.map((script) => (
        <Script key={script} type="text/javascript" src={HEADER_SCRIPTS[script]} async />
      )) }
      { schemaScripts?.map((script) => (
        <Script
          key={script.id}
          id={script.id}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(script.data),
          }}
        />
      )) }
    </DefaultHead>

    <SkipToContent />
  </>
);

const SpurredLayout: FC<ILayout> = ({
  scripts,
  schemaScripts,
  head,
  lastBuilt,

  children }) => (
  <div>
    <SharedHead
      scripts={scripts}
      schemaScripts={schemaScripts}
      head={head}
      lastBuilt={lastBuilt}
    />

    <header data-component="Header" className={"sticky top-0 w-full z-40 py-4 flex items-center bg-white print:hidden"}>
      <Container>
        <Grid>
          <Column spans={ { default: 4, lg: 5 } } justify="center">
            <Suspense>
              <BackButton />
            </Suspense>
          </Column>
          <Column spans={{ default: 4, lg: 2 }} justify="center" align="center">
            <Logo className="w-[125px] sm:w-[180px] xl:w-[180px] xl:scale-[1.5] xl:translate-y-2 transition-all duration-300" />
          </Column>
        </Grid>
      </Container>
    </header>

    <Main>
      { children }
    </Main>
  </div>
);

export default memo(SpurredLayout);
